export default __webpack_public_path__ + "static/media/alwaysFueling.b6fc67d5.jpg";